import { Link } from "react-router-dom"
import { subAdminPrivilege } from "../utils/data"
import { hasAllPrivileges } from "../utils"
const {useAuth} = require("../context/authContext")

const Layout = ({ children }) => {
    const isExactActive = (path) => location.pathname === path
    const {userData, logout} = useAuth()
    const user = userData

    return (
        // App shell: the page itself never scrolls, only the content pane
        // does. That keeps the sidebar and top bar permanently in view.
        //
        // Deliberately not `position: sticky` -- index.css sets
        // `overflow-x: hidden` on both html and body, which makes them the
        // nearest scroll container and stops sticky from pinning to the
        // viewport at all.
        <div className="flex h-screen overflow-hidden">
            {/* shrink-0 keeps the rail at its width; its own overflow-y-auto
                covers viewports too short for the full nav. */}
            <div className="flex flex-col shrink-0 h-screen overflow-y-auto min-w-[220px] px-3 py-6 bg-[#0E0E0E] border-[#414141] border-r-[1px]">
                <img src="/assets/logos/logo.svg" alt="logo" className="w-[120px]" />

                <div className="mt-[70px]">
                    <ul className="text-[#959595] gap-y-1 flex flex-col">
                        
                        <li>
                            <Link to="/" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/') ? 'bg-primary text-white' : ''}`} >
                                Dashboard
                            </Link>
                        </li>
                        {
                            (user?.role === "admin" || (user?.role === "sub-admin" && hasAllPrivileges(user?.privileges, [subAdminPrivilege.CATEGORY_MANAGER]))) &&
                            <li>
                                <Link to="/category" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/category') ? 'bg-primary text-white' : ''}`} >
                                    Category Manager
                                </Link>
                            </li>
                        }
                        {
                            (user?.role === "admin" || (user?.role === "sub-admin" && hasAllPrivileges(user?.privileges, [subAdminPrivilege.BOX_TYPE_MANAGER]))) &&
                            <li>
                                <Link to="/boxType" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/boxType') ? 'bg-primary text-white' : ''}`} >
                                    Box Type Manager
                                </Link>
                            </li>
                        }
                        {
                            user?.role === "admin" && 
                            <li>
                                <Link to="/condition" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/condition') ? 'bg-primary text-white' : ''}`} >
                                    Condition Manager
                                </Link>
                            </li>
                        }
                        {
                            user?.role === "admin" && 
                            <li>
                                <Link to="/user" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/user') ? 'bg-primary text-white' : ''}`} >
                                    User Manager
                                </Link>
                            </li>
                        }
                        {
                            user?.role === "admin" && 
                            <li>
                                <Link to="/sub-admin" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/sub-admin') ? 'bg-primary text-white' : ''}`} >
                                    Sub Admin Manager
                                </Link>
                            </li>
                        }
                        {
                            (user?.role === "admin" || (user?.role === "sub-admin" && hasAllPrivileges(user?.privileges, [subAdminPrivilege.LISTING_MANGER]))) &&
                            <li>
                                <Link to="/listing" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/listing') ? 'bg-primary text-white' : ''}`} >
                                    Listing Manager
                                </Link>
                            </li>
                        }
                        {
                            (user?.role === "admin" || (user?.role === "sub-admin" && hasAllPrivileges(user?.privileges, [subAdminPrivilege.LISTING_MANGER]))) &&
                            <li>
                                <Link to="/shopify" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/shopify') ? 'bg-primary text-white' : ''}`} >
                                    Shopify Manager
                                </Link>
                            </li>
                        }
                        {
                            (user?.role === "admin" || (user?.role === "sub-admin" && hasAllPrivileges(user?.privileges, [subAdminPrivilege.SUPPORT_MANAGER]))) &&
                            <li>
                                <Link to="/support" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/support') ? 'bg-primary text-white' : ''}`} >
                                    Chat Support Manager
                                </Link>
                            </li>
                        }
                        {
                            (user?.role === "admin" || (user?.role === "sub-admin" && hasAllPrivileges(user?.privileges, [subAdminPrivilege.SUPPORT_MANAGER]))) &&
                            <li>
                                <Link to="/email-support" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/email-support') ? 'bg-primary text-white' : ''}`} >
                                    Email Support Manager
                                </Link>
                            </li>
                        }
                        {
                            (user?.role === "admin") &&
                            <li>
                                <Link to="/incomes" className={`py-3 pl-4 rounded-[8px] block ${isExactActive('/income') ? 'bg-primary text-white' : ''}`} >
                                    Income Manager
                                </Link>
                            </li>
                        }
                    </ul>
                </div>

                <button className="flex justify-center items-center mt-auto text-white py-3 bg-[#ffffff10] rounded-[8px] text-center hover:bg-primary"
                        onClick={() => {
                            logout()
                        }}
                >
                    <img src="/assets/icons/icon-logout.svg" alt="logout" className="mr-2" />
                    Logout
                </button>
            </div>

            {/* min-w-0 lets the pane shrink below its content's intrinsic
                width, so the wide tables scroll inside their own containers
                instead of stretching the shell. */}
            <div className="flex flex-col flex-1 min-w-0 h-screen">
                <div className="h-[60px] shrink-0 border-gray border-b-[1px]"></div>

                <div className="flex-1 overflow-y-auto">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Layout